import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "timeSlotInput",
    "customTimeFields",
    "eventSelection",
    "customEventFields",
    "roomSelect",
  ];

  static values = { other: String };

  connect() {
    this.updateCustomTimeFields();
    this.updateCustomEventFields();
  }

  timeSlotChanged() {
    this.updateCustomTimeFields();
  }

  eventSelectionChanged() {
    this.updateCustomEventFields();
  }

  selectRoom(event) {
    event.preventDefault();
    if (!this.hasRoomSelectTarget) return;

    const roomId = event.currentTarget.dataset.roomId;
    if (!roomId) return;

    this.roomSelectTarget.value = roomId;
    this.roomSelectTarget.focus();
  }

  updateCustomTimeFields() {
    if (!this.hasCustomTimeFieldsTarget) return;

    const selected = this.timeSlotInputTargets.find((input) => input.checked);
    const isCustom = Boolean(selected) && selected.value === "custom";
    this.customTimeFieldsTarget.classList.toggle("d-none", !isCustom);
  }

  updateCustomEventFields() {
    if (!this.hasCustomEventFieldsTarget || !this.hasEventSelectionTarget) return;

    const isOther = this.eventSelectionTarget.value === this.otherValue;
    this.customEventFieldsTarget.classList.toggle("d-none", !isOther);

    if (isOther) {
      const input = this.customEventFieldsTarget.querySelector("input");
      if (input && document.activeElement !== input) input.focus();
    }
  }
}
